import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CookieSettingsGuard } from '@teamfoster/sdk/cookie-ngrx';
import { DictionaryGuard } from '@teamfoster/sdk/dictionary-ngrx';
import { NotFoundComponent } from './404.component';
import { LandingPagesGuard } from './landing-page/guards/landings-pages.guard';
import { ActiveLanguageGuard, LanguageGuard } from '@teamfoster/sdk/language-ngrx';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { LandingPageModule } from './landing-page/landing-page.module';

const APP_GUARDS = [ActiveLanguageGuard, LanguageGuard, DictionaryGuard, LandingPagesGuard, CookieSettingsGuard];

export const routes: Routes = [
  {
    path: 'styleguide',
    loadChildren: () => import('./style-guide/style-guide.module').then(m => m.StyleGuideModule),
    canActivate: [...APP_GUARDS],
  },
  {
    path: '404',
    component: NotFoundComponent,
    canActivate: [...APP_GUARDS],
  },
  {
    path: 'generator',
    loadChildren: () => import('./letter/letter.module').then(m => m.LetterModule),
    canActivate: [...APP_GUARDS],
  },
  {
    path: 'statistics',
    loadChildren: () => import('./statistics/statistics.module').then(m => m.StatisticsModule),
    canActivate: [...APP_GUARDS],
  },
  {
    path: '💩',
    loadChildren: () => import('./style-guide/style-guide.module').then(m => m.StyleGuideModule),
    canActivate: [...APP_GUARDS],
  },
  {
    path: '',
    loadChildren: () => import('./landing-page/landing-page.module').then(m => m.LandingPageModule),
    canActivate: [...APP_GUARDS],
  },
  {
    path: '**',
    redirectTo: '/404',
  },
];
